// Global auth handling for every API call the SPA makes.
//
// The real security boundary is the API server (it verifies the g6_session
// cookie and returns 401 when it is missing/invalid). This wrapper only:
//   1. Sends the g6_session cookie with API requests (credentials: 'include'),
//      which is required for cross-origin XHR to include cookies at all.
//   2. Redirects the browser to the dashboard sign-in on a 401 challenge, so
//      the user never sits on a broken page without a session (fail closed:
//      no API data renders without a valid session).
//
// Installed once from index.js before React renders, so it covers all fetch
// call sites without touching each component.

const DEFAULT_SIGN_IN_URL = 'https://pbdashboard.gate6.ai/sign-in';
const SIGN_IN_URL =
  process.env.REACT_APP_MARKETPLACE_SIGN_IN_URL || DEFAULT_SIGN_IN_URL;

function isApiRequest(url) {
  return typeof url === 'string' && url.includes('/api/');
}

export function installAuthFetch() {
  if (typeof window === 'undefined' || window.__pbAuthFetchInstalled) {
    return;
  }
  const nativeFetch = window.fetch.bind(window);
  window.__pbAuthFetchInstalled = true;

  window.fetch = async (input, init) => {
    const url =
      typeof input === 'string' ? input : (input && input.url) || '';
    const opts = { ...(init || {}) };

    // Attach cookies to API calls (cross-origin XHR omits them by default).
    if (isApiRequest(url) && !opts.credentials) {
      opts.credentials = 'include';
    }

    const response = await nativeFetch(input, opts);

    // Auth challenge → bounce to the dashboard sign-in.
    if (isApiRequest(url) && response.status === 401) {
      let target = SIGN_IN_URL;
      try {
        const data = await response.clone().json();
        if (data && data.sign_in_url) {
          target = data.sign_in_url;
        }
      } catch (_) {
        // Non-JSON 401 — fall back to the configured sign-in URL.
      }
      window.location.replace(target);
    }

    return response;
  };
}
